export default __webpack_public_path__ + "static/media/Coil of the Asp.bf43974a.jpg";